import { useThemeStore } from 'src/stores/theme'

export default (image = '', imageType = 'Small') => {
  const themeStore = useThemeStore()
  let theme = themeStore.theme
  let defaultProductImageURL =
    image ||
    (theme && theme.defaultProductImageURL
      ? theme.defaultProductImageURL
      : imageType == 'Large'
      ? 'images/no-image-500.png'
      : 'images/no-image-200.png')

  return defaultProductImageURL
}
